export class Carpass {
	
	constructor() {
		let url = new URL(window.location.href);
		this.mid = 13;
		this.id = 0;
	}

	selectAccounts(parent)
	{
		let _this = this;
		$.ajax({
			url: "/vsop/ajax/13/",
			type: 'POST',
			data: 'action=select&data=' + $('#data').val(),
			dataType: "json",
			success: function(res){
				_this.data = res;

				$.each(res, function(i, a){
					var str = '<tr><td>'+a.STR_1CID+'</td>';
					str += '<td>'+a.SLT_ACCOUNTS+'</td><td>'+a.STR_NAME+'</td><td>'+a.STR_CARNUM+'</td></tr>'
					var t = $(str);
					$('tbody#accounts').append(t)
				});
			},
			error: function(err){
				console.log(err);
			}
		});
	}

	blockPasses()
	{
		let _this = this;
		if($('#reason').val() == '-1' || data == undefined)
		{
			alert('Укажите счета для бокировки');
		}
		else
		{
			$.ajax({
				url: "/vsop/ajax/13/",
				type: 'POST',
				data: 'action=add&reason=' + $('#reason').val() + "&json=" + JSON.stringify(_this.data),
				dataType: "json",
				success: function(res)
				{
					console.log(res);
					alert('Данные добавлены');
				},
				error: function(err)
				{
					console.log(err);
				}
			});
		}
	}

	applyEvents()
	{
		let replaceObj = {
			Й: "Y",
			Ц: "C",
			У: "Y",
			К: "K",
			Е: "E",
			Н: "H",
			Г: "G",
			Ш: "SH",
			Щ: "SCH",
			З: "Z",
			Х: "X",
			Ъ: "",
			Ф: "F",
			Ы: "Y",
			В: "B",
			А: "A",
			П: "P",
			Р: "P",
			О: "O",
			Л: "L",
			Д: "D",
			Ж: "ZH",
			Э: "E",
			Я: "YA",
			Ч: "CH",
			С: "C",
			М: "M",
			И: "I",
			Т: "T",
			Ь: "",
			Б: "B",
			Ю: "YU",
			Ё: "YO",
		};
		$('input[name=str_carnum]').on('input', function(){
			this.value = this.value.toUpperCase().replace(/[А-Я]/gi, function (matched) {
				return replaceObj[matched];
			}).replace(/[^A-Z0-9]/gi, '');
		});
	}
}